
export class ProduktinstruktionSearchRequestDTO   {

    puid: string;
    namn: string;
    sortimentExternt: string;
    mottagningsplatsExternt: string;

    constructor() {
        this.puid = undefined;
        this.namn = undefined;
        this.sortimentExternt = undefined;
        this.mottagningsplatsExternt = undefined;
    }
}
